import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  RespCode,
  ErrorCode,
  env,
  // ClaimType,
  TOTAL_MONEY_LIMIT_FOR_CHECKED, ErrorCodeToSpecialText,
} from '@constants';
import { submitClaim, reportEvent, getReviewQuote } from '@api';
import { logError } from '@log';
import { regEmail, ClaimType } from '@constants/claim';
import { useReviewData, useEffectOnce } from '@hooks';
import { clearSelectedItems, setClaimList } from '@store/slices';
import { isUserMobile } from '@/utils';

export const useReview = () => {
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [quotePrice, setQuotePrice] = useState('0.00 USD');
  const {
    files, comments,
    type,
    orderName, selectedData, selectedPackageList, paymentMethod, totalMoneyValue, returnMethod, reviewData,
  } = useSelector((state) => state.claim);
  const {
    reasonList, platform, email, behaviorData, specialPlatform, orderNumber,
  } = useSelector((state) => state.policy);
  const [customEmail, setCustomEmail] = useState(email);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { getReviewData } = useReviewData();
  const [bpChecked, setBPChecked] = useState(totalMoneyValue > TOTAL_MONEY_LIMIT_FOR_CHECKED);
  const handleChange = (event) => {
    setIsConfirmed(event.target.checked);
  };

  const handleEmailChange = (e) => {
    const val = e.target.value;
    if (regEmail.test(val)) {
      setCustomEmail(val);
    } else {
      setCustomEmail('');
    }
  };

  const onClickContinue = async () => {
    const url = env === 'prod' ? 'https://api.seel.com/gateway/ins-claim-product/api/resolution-center/report-event' : 'https://api-dev.seel.com/gateway/ins-claim-product/api/resolution-center/report-event';

    try {
      setIsLoading(true);

      const resp = await submitClaim({ ...selectedData, applicantEmail: customEmail });
      const reportData = {
        ...behaviorData,
        submitTime: `${Date.now()}`,
        platform,
        isMobile: isUserMobile(),
        orderNumber,
        email,
        host: window.location.host,
      };

      setIsLoading(false);
      const { code, data, message } = resp;
      if (code !== RespCode.Success) {
        // 失败上报
        reportEvent(url, { ...reportData, status: 'fail', failureReason: message || code });

        if (ErrorCodeToSpecialText.includes(code)) {
          navigate('../error', { state: { code, message } });
        } else {
          navigate('../error', { state: { code: ErrorCode.Wrong } });
        }
        return;
      }
      // 成功上报
      reportEvent(url, { ...reportData, status: 'success' });
      // claimList从登录接口拿到，当理赔申请成功后，需要新增一条  原来feedback接口只能返回当前保单所有claim，不能跨保单获取
      dispatch(setClaimList({ claimId: data.claimId, status: 'In Progress' }));

      dispatch(clearSelectedItems());
      navigate(`../feedback?claimId=${data.claimId}`);
    } catch (error) {
      logError(error);
    }
  };

  const handleWidgetChange = async (value) => {
    const isSuccess = await getReviewData({ useShippingLabel: returnMethod.value === '1', includeBp: value });
    if (isSuccess) {
      setBPChecked(value);
    }
  };
  useEffectOnce(async () => {
    if (type === ClaimType.RA) {
      const { premium: { presentation } = {} } = await getReviewQuote({
        ...selectedData,
        includeBp: true,
      });
      setQuotePrice(presentation);
    }
  });
  return {
    files,
    // files1,
    email,
    comments,
    platform,
    specialPlatform,
    orderName,
    type,
    reviewData: { ...reviewData, ...paymentMethod, shippingOnOwn: returnMethod.value === '2' },
    reasonList,
    selectedPackageList,
    isConfirmed,
    isLoading,
    customEmail,
    bpChecked,
    quotePrice,
    handleWidgetChange,
    onClickContinue,
    handleChange,
    handleEmailChange,
  };
};
